<script lang="ts">
	//# SVELTE
	import { format } from 'svelte-i18n';
	import { confirmPasswordReset } from '../services/http';
	//Design system components
	import { Button, Text, Input, toast } from '@Shelly/shelly-design-system';

	export let params: { email?: string; token?: string };

	let pass = '',
		pass_repeat = '',
		pass_error,
		email = params?.email || '',
		token = params?.token || '';

	const clear_errors = () => {
		if (pass_error) {
			pass_error = undefined;
		}
	};

	const submit_req = () => {
		confirmPasswordReset(token, pass);
	};

	const check_password = () => {
		if (pass !== pass_repeat) {
			pass_error = $format('error_passwords_match');
			return toast.open({
				type: 'danger',
				title: $format('error_passwords_match'),
			});
		} else {
			clear_errors();
			submit_req();
		}
	};
</script>

<Text element="h1" class="text-center mb-m"
	>{$format('title_change_email', { default: 'Change E-mail' })}</Text
>

<Input
	id="input-request-pass-reset"
	aria-labelledby="input-request-pass-reset"
	size="l"
	class="mb-m"
	label={$format('text_new_email', { default: 'New E-mail' })}
	type="email"
/>

<Button class="mb-m" variant="primary" width="full" on:click={() => {}}>
	{$format('button_save', { default: 'Save' })}
</Button>

<Button variant="secondary" width="full" on:click={() => {}}>
	{$format('button_cancel', { default: 'Cancel' })}
</Button>
